const year = new Date().getFullYear();
const addToCart = "Add to Cart";
const removeFromCart = "Added!";

export default {
  "guide.name": "American National Bank of Texas",
  "guide.subtitle": "Your Bank For Life",
  guideStartTime: "Guide Started at",
  guideEndTime: "Guide Ended at",
  completedPaths: "Completed Guide Path",
  "completedPaths.consumer-guide": "Consumer Guide",
  channel: "Guide delivered via channel",
  "header.menu-start-new-guide": "Start New Guide",
  "header.menu-start-over": "Start Over",
  "header.menu-exit": "End Session",
  pleaseSelect: "Please Select a Value",

  "landing.getStarted": "Get Started",
  "summary.actions.print": "Print",
  "summary.actions.email": "Email",
  "summary.actions.text": "Text",
  "summary.actions.back": "Back",
  "summaryPage.icon": "/classpath/assets/images/blueStar.svg",
  "detailsPage.icon": "/classpath/assets/images/blueStar.svg",
  "detailsPage.bankingStyle": "What You Told Us About Your Banking Style",

  "cart.title": "Your Solutions",
  "cart.subtitle": "Choose the ANBTX Solutions that best fit your needs. Once submitted, an ANBTX banker will reach out to you with more information and to help you personally set up your accounts.",
  "cart.products": "Products",
  "cart.goals": "Goals",
  "cart.remove": "X",
  "cart.empty.products": "Your cart contains no products",
  "cart.empty.goals": "Your cart contains no goals",
  "cart.submit.toast.successText": "Your information has been submitted!",
  "cart.navigation.next": "Next",
  "cart.navigation.back": "Back",
  addToCart: addToCart,
  removeFromCart: removeFromCart,
  "cart.confirmDelete.title": "Are you sure you want to remove this item from your cart?",
  "cart.confirmDelete.message": "Are you sure you want to remove ",
  "cart.confirmDelete.button": "Yes please",
  "cart.noConfirmDelete.button": "Cancel",
  "cart.label": "Cart",

  "product.learnMore.button": "Learn more",

  privacyPolicy: "Privacy Policy",
  copyright: "Copyright © " + year + " American National Bank of Texas | NMLS #445248",

  "error.title": "Errors",
  "error.question.required": "Must be answered",
  "error.question.between": "Value must be between {0} and {1}",
  "error.questionGroup.required": "You must answer a question",
  "error.questionGroup.between": "Total value must be between {0} and {1}",
  "error.questionGroup.equal": "Total value must equal to {0}",

  "shareViaEmail.title": "Email Results",
  "shareViaEmail.submitted": "Your email has been successfully sent",
  "shareViaEmail.label": "Email address",
  "shareViaEmail.button": "Send Email",
  "shareViaEmail.placeholder": "user@email.com",
  "shareViaEmail.submitted.success.title": "Email Sent",
  "shareViaEmail.submitted.success.message":
    "Your results have been sent to the email address you provided",

  "shareViaSms.title": "Text Results",
  "shareViaSms.submitted": "Your message has been successfully sent",
  "shareViaSms.message":
    "Enter your phone number to receive a one time text message with a link to your product recommendations. <em>Message and Data rates may apply.</em>",
  "shareViaSms.label": "Phone Number",
  "shareViaSms.button": "Send Message",
  "shareViaSms.placeholder": "(800) 555-1234",

  "contact.title": "We'll contact you",
  "contactMe.firstName": "First Name",
  "contactMe.firstName.placeholder": "First Name",
  "contactMe.firstName.error": "First Name is required",
  "contactMe.lastName": "Last Name",
  "contactMe.lastName.placeholder": "Last Name",
  "contactMe.lastName.error": "Last Name is required",
  "contactMe.email": "Email",
  "contactMe.email.error": "A valid email address is required",
  "contactMe.phone": "Phone",
  "contactMe.phone.error": "A valid 10-digit US phone number is required",
  "contactMe.submit": "Send",
  "contact.agreeTerms":
    'Agree to our <a href="#">Privacy Policy</a> and <a href="#">Terms and Conditions</a>',
  "contact.agreeTerms.error":
    "You must agree with our terms and conditions before continue",
  "contact.button": 'Schedule an Appointment',
  "contact.button.phone":
    'Contact Us',
};
